import { useQueryClient, QueryObserver } from '@tanstack/react-query';
import { useCallback } from 'react';

const useQueryCallback = (queryKey: (string | null | undefined)[]) => {
  const queryClient = useQueryClient();

  const addCallback = useCallback(
    (callback: () => void) => {
      const observer = new QueryObserver(queryClient, { queryKey });

      const unsubscribe = observer.subscribe((result) => {
        console.log({ result });
        if (result.status === 'success' && !result.isFetching) {
          callback();
          observer.destroy();
        }
      });

      return unsubscribe;
    },
    [queryClient, queryKey]
  );

  return { addCallback };
};

export default useQueryCallback;
